'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.requiredValidation = requiredValidation;
exports.defaultErrorMessage = defaultErrorMessage;
exports.requiredErrorMessage = requiredErrorMessage;

var _utils = require('../utils/utils');

var _domUtils = require('../utils/dom-utils');

var _cssClasses = require('../constants/css-classes');

var cssClasses = _interopRequireWildcard(_cssClasses);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function requiredValidation(value) {
  return value.trim() !== '';
}

function defaultErrorMessage(fieldName) {
  return 'The field ' + (0, _utils.capitalizeAll)((0, _utils.camelCaseToSpace)(fieldName)) + ' is not valid';
}

function requiredErrorMessage(fieldName) {
  return 'The field ' + (0, _utils.capitalizeAll)((0, _utils.camelCaseToSpace)(fieldName)) + ' is required';
}

function getCssClasses(id) {
  var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return [cssClasses.FORM_INPUT_VALIDATION_MESSAGE, cssClasses.FORM_INPUT_VALIDATION_MESSAGE + '-' + id, isError && cssClasses.FORM_INPUT_VALIDATION_MESSAGE_ERROR, 'hs-form-field'].filter(Boolean);
}

function getStickyCssClasses(id) {
  return [cssClasses.FORM_INPUT_VALIDATION_MESSAGE, cssClasses.FORM_INPUT_VALIDATION_MESSAGE + '-' + id + '-sticky', cssClasses.FORM_INPUT_VALIDATION_MESSAGE_ERROR, 'hs-form-field'];
}

var FormElement = function () {
  function FormElement(_ref) {
    var id = _ref.id,
        _ref$selector = _ref.selector,
        selector = _ref$selector === undefined ? 'input' : _ref$selector,
        _ref$errorSelector = _ref.errorSelector,
        errorSelector = _ref$errorSelector === undefined ? selector : _ref$errorSelector,
        validationRule = _ref.validationRule,
        validationRules = _ref.validationRules,
        formFields = _ref.formFields;

    _classCallCheck(this, FormElement);

    this.id = id;
    this.selector = selector;
    this.errorSelector = errorSelector;
    this.validationRule = validationRule;
    this.validationRules = validationRules;
    this.formFields = formFields;
    this.valid = true;
    this.touched = false;

    this.handleBlur = this.handleBlur.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  _createClass(FormElement, [{
    key: 'init',
    value: function init() {
      this.element = document.querySelector(this.selector);
      this.errorElement = document.querySelector(this.errorSelector);
      this.element.addEventListener('blur', this.handleBlur);
      this.element.addEventListener('input', this.handleInput);
    }
  }, {
    key: 'validate',
    value: function validate() {
      var _this = this;

      if (this.validationRule) {
        return this.validateSingleRule(this.validationRule);
      }

      if (this.validationRules && Array.isArray(this.validationRules)) {
        return this.validationRules.reduce(function (acc, curr) {
          return acc && _this.validateSingleRule(curr);
        }, true);
      }

      return this.valid;
    }
  }, {
    key: 'validateSingleRule',
    value: function validateSingleRule(rule) {
      var validation = _utils.truthy;
      var errorMessage = defaultErrorMessage;

      if (rule) {
        if ((0, _utils.isFunction)(rule)) {
          validation = rule;
          errorMessage = rule === requiredValidation && requiredErrorMessage || errorMessage;
        } else if ((0, _utils.isObject)(rule) && (0, _utils.isFunction)(rule.validation)) {
          validation = rule.validation;
          errorMessage = rule.errorMessage || errorMessage;
        }

        this.valid = validation(this.getValue(), this.formFields);
        this.touched = true;
        if (!this.valid) {
          this.error(errorMessage);
        }
      }

      return this.valid;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.element.value;
    }
  }, {
    key: 'error',
    value: function error() {
      var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultErrorMessage;

      var message = (0, _utils.isFunction)(errorMessage) ? errorMessage(this.id) : errorMessage;
      var errorElement = '\n    <div class="' + getCssClasses(this.id, true).join(' ') + '">\n      <ul class="no-list hs-error-msgs">\n        <li>\n          <label class="hs-error-msg">' + message + '</label>\n        </li>\n      </ul>      \n    </div>\n    ';

      this.element.parentElement.insertBefore((0, _domUtils.createElementFromHTML)(errorElement), this.element.nextSibling);
      this.element.classList.add(cssClasses.FORM_INPUT_ERROR);
    }
  }, {
    key: 'stickyError',
    value: function stickyError(errorMessage) {
      var errorElement = '\n    <div class="' + getStickyCssClasses(this.id).join(' ') + '">\n      <ul class="no-list hs-error-msgs">\n        <li>\n          <label class="hs-error-msg">' + errorMessage + '</label>\n        </li>\n      </ul>   \n    </div>\n    ';

      this.errorElement.parentElement.insertBefore((0, _domUtils.createElementFromHTML)(errorElement), this.errorElement.nextSibling);
      this.element.classList.add(cssClasses.FORM_INPUT_ERROR);
    }
  }, {
    key: 'removeError',
    value: function removeError() {
      var _this2 = this;

      var parentElement = this.element.parentElement;
      var errorNotificationSelector = getCssClasses(this.id).map(function (className) {
        return '.' + className;
      }).join('');
      var errorNotification = document.querySelectorAll(errorNotificationSelector, parentElement);
      Array.prototype.forEach.call(errorNotification, function (node) {
        if ((0, _utils.isDOMNode)(node)) {
          node.parentNode.removeChild(node);
        }
        _this2.element.classList.remove(cssClasses.FORM_INPUT_ERROR);
      });
    }
  }, {
    key: 'removeStickyError',
    value: function removeStickyError() {
      var _this3 = this;

      var parentElement = this.element.parentElement;
      var errorNotificationSelector = getStickyCssClasses(this.id).map(function (className) {
        return '.' + className;
      }).join('');
      var errorNotification = document.querySelectorAll(errorNotificationSelector, parentElement);
      Array.prototype.forEach.call(errorNotification, function (node) {
        if ((0, _utils.isDOMNode)(node)) {
          node.parentNode.removeChild(node);
        }
        _this3.element.classList.remove(cssClasses.FORM_INPUT_ERROR);
      });
    }
  }, {
    key: 'resetValidation',
    value: function resetValidation() {
      this.valid = true;
      this.touched = false;
      this.removeError();
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      if (this.touched) {
        this.removeError();
        this.validate();
      }
    }
  }, {
    key: 'handleInput',
    value: function handleInput() {
      this.removeStickyError();
    }
  }]);

  return FormElement;
}();

exports.default = FormElement;


//////////////////
// WEBPACK FOOTER
// ./js/validation/FormElement.js
// module id = 1
// module chunks = 0 1 2 3